module.exports = __webpack_public_path__ + "static/media/epic-logo@2x.3a59189e.png";